
import { getQrCode, getTerminalDetail, saveQrCode } from '@/common/js/api.js'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'


export default {
components: {
Scroller,
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Icon,
Sticky
},
methods: {
getQrCode(orderId, qrCode) {
let self = this
getQrCode({ data: { orderId: orderId, qrCode: qrCode } }).then(function(
data
) {
self.entity = data.Content
})
},
saveQrCode(orderId, qrCode) {
let self = this
this.$vux.confirm.show({

title: '提醒您',
content: '确定执行此操作吗？',
onCancel() {},
onConfirm() {
saveQrCode({
data: {
orderId: self.entity.order.orderId,
qrCode: self.entity.qrCode.code,
workOrderId: self.workOrderId ? self.workOrderId : undefined
}
}).then(function(data) {
self.$vux.toast.text('保存成功')
setTimeout(function() {
history.go(-1)
}, 2000)
})
}
})
},
getTerminalDetail() {
let self = this
getTerminalDetail({ data: { terminalId: self.sid } }).then(function(
data
) {
self.currentTerminal = data.Content
})
}
},
mounted() {
let self = this
self.sid = self.$route.query.sid
self.workOrderId = self.$route.query.workOrderId

this.getQrCode(this.$route.query.orderId, this.$route.query.qrCode)
},
activated() {

console.log('activated')
},
data() {
return {
entity: null,
sid: null,
workOrderId: null
}
}
}



// WEBPACK FOOTER //
// ./src/components/support/OrderScan.vue